import { action, computed, makeObservable, observable, runInAction } from "mobx";
import { ApplicationSdk } from "..";
import { DEFAULT_MAX_ENTRIES } from "../../constant";

class TmpCleaner {
    private sdk: ApplicationSdk;
    public loading: boolean = false;
    public cleanerList: Array<any> = [];

    constructor(sdk: ApplicationSdk) {
        makeObservable(this, {
            loading: observable,
            cleanerList: observable,
            fetch: action,
            all: computed
        });
        this.sdk = sdk;
    }

    public async fetch(): Promise<void> {
        runInAction(() => {
            this.loading = true;
        })

        const cleanerList: any = await this.sdk.fetchApi(
            'cleaner',
            'query',
            {
                format: 'simple',
                limit: 999
            }
        );

        runInAction(() => {
            this.loading = false;

            if (cleanerList?.status === 200) {
                this.cleanerList = (cleanerList.json.data || this.cleanerList || []).map((cleaner: any) => ({
                    ...cleaner,
                    name: `${cleaner.firstname} ${cleaner.lastname}`,
                }));
            }
        });
    }

    get all() {
        return {
            filter: (search: string, maxEntries: number = DEFAULT_MAX_ENTRIES) => {
                return this.cleanerList
                    .filter((cleaner: any) => {
                        return cleaner.name.toLowerCase().includes(search.toLowerCase());
                    })
                    .slice(0, maxEntries); // Limit the results to maxEntries
            },
            data: this.cleanerList
        };
    }
}

export default TmpCleaner;